<template>
  <div class="">
    <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
      <b-card
        class="card text-center"
        style="background-color: #f5f6fa; box-shadow: none"
        border-variant="primary"
        header="DOCUMENTS"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">DOCUMENTS</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i
                  style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  "
                  class="tim-icons icon-simple-remove"
                  @click="modals.supportdoc = false"
                ></i>
              </base-button>
            </div>
          </div>
        </template>

        <div
          v-if="jobno.toLowerCase().includes('v')"
          :style="{
            height: msdsopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allmaterialname"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" label="" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="msdsopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>

              <el-table-column
                label="Manifold Plan / Diagram"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="msdsopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>

              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="msdsopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          v-if="jobno.toLowerCase().includes('v')"
          :style="{
            height: stowageopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allstowagename"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="stowageopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Stowage Plan"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="stowageopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="stowageopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          :style="{
            height: otheropen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allfilename"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Job Supporting Documents"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="otheropen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          :style="{
            height: quoopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allquodocname"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <span @click="openquo()" style="cursor: pointer">{{
                    scope.column.label
                  }}</span>
                </template>
                <div v-if="quoopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Quotation Supporting Documents"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="quoopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="" width="100" align="center">
                <div v-if="quoopen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title" v-if="landvesselflag == 'LAND'">
                Collection Date
              </p>
              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Arrival ETA
              </p>
              <p class="subtitle">{{ arrivalETA }}</p>

              <p class="new-title" >
                Service Location
              </p>
              <p class="subtitle" >
                {{ servicelocation }}
              </p>

              <p class="new-title">
                Service Location Collection
              </p>
              <p class="subtitle">
                {{ servicelocationcollection }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Departure (ETD)
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ departureETD }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Previous Port
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ previousPort }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Next Port
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ nextPort }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Last Port When Generated Waste Delivered
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ lastPortAndDate }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Last Date When Generated Waste Delivered
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ lastDate }}
              </p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Ship Name
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ shipName }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">IMO No.</p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ imoNo }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Ship Type
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ shipType }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Gross Tonnage
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ grossTonnage }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Deadweight Tonnage (kg)
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ deadweightTonnage }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Owner / Operator Name
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ owneroperatorname }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Call Sign
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ callSign }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Flag State
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ flagState }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Sustainable Certificates
              </p>
              <div v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0" v-for="(file, index) in shipdoc"
                :key="'allship_file' + index" class="row">
                <div class="col-lg-8">
                  {{ index + 1 }}.
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
              </div>
              <p v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0" class="subtitle">
                None
              </p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex">
          <card class="card-eprf" v-if="landvesselflag == 'VESSEL'">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>

              <div class="col-lg-3 text-right" v-if="positionid != 4">
                <div class="row">
                  <div class="col-lg">Marketing Channel:</div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <el-select v-model="cancelledref" filterable>
                      <el-option
                        class="select-primary"
                        v-for="(item, index) in cancelledrefs"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div
              class="row"
              style="height: 520px; overflow: auto; overflow-x: hidden"
            >
              <div class="col-lg">
                <el-table
                  :data="wastedetails"
                  :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',

                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }"
                  :cell-style="{ fontColor: '#707070' }"
                  :row-style="tableRowClassName"
                >
                  <el-table-column label="NO." width="50" align="center">
                    <div slot-scope="scope">
                      <p style="color: #707070">{{ scope.$index + 1 }}</p>
                    </div>
                  </el-table-column>

                  <el-table-column
                    label="WASTE TYPE"
                    prop="wastetype"
                    :min-width="200"
                    align="center"
                  >
                    <div slot-scope="{ row }">
                      <div align="left">
                        <p style="color: #A5A5A5">
                          Waste Type: {{ row.wastetype }}
                        </p>
                        <p style="color: #A5A5A5">
                          Waste Sub Type: {{ row.wastetypesub }}
                        </p>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column
                    label="WASTE QTY."
                    :min-width="50"
                    align="center"
                    prop="wasteqty"
                  >
                  </el-table-column>
                  <el-table-column
                    :min-width="150"
                    align="center"
                    label="MAX DEDICATED STORAGE CAPACITY"
                    prop="maxdedicatedstoragecapacity"
                  ></el-table-column>
                  <el-table-column
                    :min-width="155"
                    align="center"
                    label="WASTE AMOUNT RETAINED ON-BOARD"
                    prop="wasteamountretainedonboard"
                  ></el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    label="REMARKS"
                    prop="remarks"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
          <card class="card-eprf" v-if="landvesselflag == 'LAND'">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>
              <div class="col-lg"></div>
              <div class="col-lg-3 text-right" v-if="positionid != 4">
                <div class="row">
                  <div class="col-lg">Marketing Channel:</div>
                </div>

                <div class="row">
                  <div class="col-lg">
                    <el-select v-model="cancelledref" filterable>
                      <el-option
                        class="select-primary"
                        v-for="(item, index) in cancelledrefs"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div
              class="row"
              style="height: 520px; overflow: auto; overflow-x: hidden"
            >
              <div class="col-lg">
                <el-table
                  :data="wastedetails"
                  :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }"
                  :cell-style="{ fontColor: '#707070' }"
                  :row-style="tableRowClassName"
                  style="color: #707070"
                >
                  <el-table-column label="NO." width="50" align="center">
                    <div slot-scope="scope">
                      <p style="color: #707070">{{ scope.$index + 1 }}</p>
                    </div>
                  </el-table-column>

                  <el-table-column
                    :min-width="200"
                    align="center"
                    label="WASTE TYPE"
                    prop="wastetype"
                  >
                    <div slot-scope="{ row }">
                      <div align="left">
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #707070">
                              Waste Type: {{ row.wastetype }}
                            </p>
                            <p style="color: #707070" class="swcode-text">
                              SW Code: {{ row.wastecatalyst }}
                            </p>
                            <p style="color: #707070">
                              Packaging: {{ row.packagingtype }}
                            </p>
                            <p style="color: #707070">
                              Waste Origin: {{ row.wasteorigin }}
                            </p>
                          </div>
                        </div>

                        <div
                          class="row"
                          v-for="(item, index) in row.image"
                          :key="index"
                          style="
                            border: 1px solid #e6e6e6;
                            width: 100%;
                            margin-left: 3px;
                          "
                        >
                          <div class="col-lg-3" style="padding: 5px">
                            <img
                              :src="item.url"
                              width="70"
                              height="40"
                              @click="openimage(item.url)"
                            />
                          </div>
                          <div class="col-lg">
                            <p
                              style="
                                color: #A5A5A5;
                                white-space: nowrap;
                                width: 70px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 10px;
                                line-height: 1em;
                              "
                            >
                              {{ item.meta.filename }}
                            </p>
                            <p
                              style="
                                color: grey;
                                line-height: 0.5;
                                font-size: 10px;
                              "
                            >
                              {{ item.meta.filesize }}
                            </p>
                          </div>
                          <div
                            class="col-lg-3 text-center"
                            style="border-left: 1px solid #e6e6e6"
                          >
                            <base-button class="btn-icon btn-link">
                              <a :href="item.url"
                                ><img
                                  src="@/assets/img/eprf-download-grey.png"
                                  width="20" /></a
                            ></base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="150"
                    align="center"
                    label="WASTE COMPONENT"
                    prop="wastecomponent"
                  >
                    <div slot-scope="scope">
                      <div
                        v-for="(item, index) in scope.row.wastecomponent"
                        :key="index"
                      >
                        <p style="color: #707070">
                          {{ index + 1 }}. {{ item.waste_component_name == null || item.waste_component_name == '' ? 'N/A' : item.waste_component_name }}
                        </p>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="150"
                    align="center"
                    label="EST. QTY."
                    prop="estqty"
                  >
                    <div slot-scope="{ row }">
                      {{ row.estqty }}<br />
                      {{ row.estqtyy }}
                    </div>
                  </el-table-column>

                  <el-table-column
                    :min-width="120"
                    align="center"
                    label="REMARKS"
                    prop="remarks"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4"></div>
        <!-- <div class="col-lg text-right"></div> -->

        <div class="col-lg-3 text-left">
          <base-button @click="modals.supportdoc = true" type="primary"
            >View Documents</base-button
          >
        </div>
        <div class="col-lg text-right">
          <base-button
            v-if="positionid != 4 && step == 1"
            wide
            type="cancel"
            @click="modals.disputereason = true"
            class="btn-dispute"
          >
            DISPUTE
          </base-button>
          <base-button
            type="primary"
            wide
            @click="accept()"
            class="btn-next"
            v-if="positionid != 4 && step == 1"
          >
            ACCEPT
          </base-button>
          <base-button
            type="primary"
            wide
            @click="nextTab"
            class="btn-next"
            v-if="positionid == 4"
          >
            NEXT
          </base-button>
          <base-button
            type="primary"
            wide
            @click="nextTab"
            class="btn-next"
            v-if="positionid != 4 && step != 1"
          >
            NEXT
          </base-button>
        </div>
      </div>
    </div>

    <StatusModal
      :show.sync="modals.successModal"
      :message="modal.jobaccept"
      :title="modal.successTitle"
    />
    <StatusModal
      :show.sync="modals.removeModal"
      :message="modal.remove"
      :title="modal.removeTitle"
    />
    <StatusModal
      :show.sync="modals.successUpload"
      :message="modal.success"
      :title="modal.successTitle"
    />

    <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
      <b-card
        class="card text-center"
        style="background-color: #f5f6fa; box-shadow: none"
        border-variant="primary"
        header="REASON FOR DISPUTE"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">REASON FOR DISPUTE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i
                  style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  "
                  class="tim-icons icon-simple-remove"
                  @click="modals.disputereason = false"
                ></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-12">
            <textarea
              type="textarea"
              placeholder="Reason for rejection..."
              v-model="reason"
              :class="{ textarea: true }"
            ></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-1">
            <div class="fileinput">
              <label
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
                for="file-upload"
                type="primary"
                class="btn"
              >
                Upload
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="file-upload"
                ref="file"
                type="file"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onFileChange"
              />
            </div>
          </div>

          <div class="col-lg text-left">
            <div class="row">
              <p class="" style="margin-left: 80px; color: #A5A5A5">
                {{
                  quotitle.length > 30
                    ? quotitle.slice(0, 30) + "..."
                    : quotitle
                }}
              </p>
              <i
                v-if="quotitle.length > 0"
                style="
                  color: #ff0000;
                  font-weight: 900;
                  font-size: 20px;
                  margin-left: 10px;
                  margin-top: 20px;
                "
                class="tim-icons icon-simple-remove"
                v-on:click="deletedisputedoc()"
              ></i>
            </div>
          </div>
          <div class="col-lg-4 text-right">
            <base-button type="primary" v-on:click="dispute()"
              >Submit</base-button
            >
          </div>
        </div>
      </b-card>
    </modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { colors } from "../../../../../components/colors.js";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
import { Circle8 } from "vue-loading-spinner";

export default {
  props: ["parentData"],
  name: "first-step",
  components: {
    StatusModal,
    BCard,
    colors,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Modal,
    Circle8,
  },
  props: ["first-step"],
  data() {
    return {
      msdsopen: false,
      stowageopen: false,
      otheropen: false,
      quoopen: false,
      msds: "",
      stowage: "",
      otherdoc: "",
      allfilename: [],
      allmaterialname: [],
      allstowagename: [],
      allquodocname: [],

      disputedocid: 0,
      quotitle: "",
      modal: modal,
      positionid: "",
      cancelledref: "",
      cancelledrefs: [],
      uploadload: false,
      step: 0,
      jobno: "",
      arrivalETA: "18 Nov 2022",
      servicelocation: "",
      servicelocationcollection: "",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      lastDate: "",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      reason: "",
      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
          estqtyy: "300 M3",
        },
      ],
      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },
      jobstatus: "",
      landvesselflag: "",
      modals: {
        disputereason: false,
        successModal: false,
        successUpload: false,
        removeModal: false,

        msdsdoc: false,
        stowagedoc: false,
        supportdoc: false,
      },
      message: "",
    };
  },
  created() {
    this.jobstatus = this.$route.params.jobnum.split("_")[1];
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    console.log(this.positionid);
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getMarketingChannel();
    this.getDetail(this.jobno);
  },
  mounted() {},

  computed: {
    dynamicHeight() {
      return this.msdsopen ? "400px" : "120px";
    },
  },

  methods: {
    openmsds() {
      console.log("okay ke?");

      this.msdsopen = !this.msdsopen;
    },
    openstowage() {
      console.log("okay ke?");

      this.stowageopen = !this.stowageopen;
    },
    openother() {
      console.log("okay ke?");

      this.otheropen = !this.otheropen;
    },
    openquo() {
      console.log("okay ke?");

      this.quoopen = !this.quoopen;
    },
    sendMarketingChannel() {
      let obj = {
        marketing_channel_id: this.cancelledref,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getMarketingChannel() {
      this.$http
        .get(":10001/api/v1/setting-private/marketing_channel")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                value: response[i].marketing_channel_id,
                label: response[i].name,
              };
              this.cancelledrefs.push(obj);
            }

            this.cancelledref = this.cancelledrefs[0].value;
          }
        });
    },
    // saveDraft() {},
    onFileChange(event) {
      this.upload = true;
      const t = event.target;

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);

          this.quotitle = t.files[i].name;

          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/upload/dispute-waste-job?mobile",
              this.docs,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                console.log("data masuk", response);

                this.modals.successUpload = true;

                this.uploadload = false;

                this.disputedocid = response.document_id;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });

                this.uploadload = false;
              }
            });

          this.buttondisabled = false;
        }
      }
    },
    deletedisputedoc() {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/upload/dispute-waste-job/" +
                this.disputedocid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.quotitle = "";

                this.modals.removeModal = true;
              }
            });
        }
      });
    },
    dispute() {
      if (this.reason != "") {
        let obj = {
          dispute_reason: this.reason,
        };
        this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/dispute", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              this.modals.disputereason = false;
              this.exitTab();
            }
          });
      } else {
        // reason is compulsory
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    accept() {
      let obj = {
        marketing_channel_id: this.cancelledref,
      };
      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;

            this.modals.disputereason = false;
            this.getDetail(this.jobno);
            setTimeout(() => {
              this.nextTab();
            }, 1000);
          }
        });
    },
    getDetail(refNo) {
      this.wastedetails = [];
      this.allfilename = [];
      this.allmaterialname = [];
      this.allstowagename = [];
      this.allquodocname = [];
      this.shipdoc = [];

      this.$http.get(":10001/api/v1/incoming/" + refNo).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("hoi");
          console.log(response);

          this.landvesselflag = response.company.company_type.toUpperCase();

          this.step = response.step;
          this.arrivalETA = moment(response.arrival_eta).format("DD MMM YYYY");

          this.servicelocation = response.service_location_name;
          this.servicelocationcollection =
            response.service_location_collection_name;

          this.departureETD = moment(response.departure_eta).format(
            "DD MMM YYYY"
          );
          this.previousPort =
            response.previous_port == "" ? "None" : response.previous_port;
          this.nextPort =
            response.next_port == "" ? "None" : response.next_port;
          this.lastPortAndDate =
            response.last_port == "" ? "None" : response.last_port;

          this.lastDate =
            response.last_port_date == ""
              ? "N/A"
              : moment(response.last_port_date).format("DD MMM YYYY");
          console.log(this.lastDate);
          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;
          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
            response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
            response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.user_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
            response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
            response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);
          this.picEmail = response.pic.user_email;
          this.shipName = response.ship.ship_name;
          this.imoNo = response.ship.imo_number;
          this.shipType = response.ship.ship_type_name;
          this.grossTonnage = response.ship.gross_tonnage;
          this.deadweightTonnage = response.ship.deadweight_tonnage;
          this.owneroperatorname = response.ship.operator_name;
          this.callSign = response.ship.call_sign;
          this.flagState = response.ship.country_name;
          // this.sustainableCertificates =
          //   response.ship.documents == null ? "None" : response.ship.documents;

          if (response.ship.documents != null) {
            for (var i = 0; i < response.ship.documents.length; i++) {
              let obj = {
                filename: response.ship.documents[i].meta.filename,
                fileid: response.ship.documents[i].ship_document_id,
                fileurl: response.ship.documents[i].url,
              };
              this.shipdoc.push(obj);
            }
          }

          // get material safety file
          if (response.material_safety_data_sheet != null) {
            for (
              var i = 0;
              i < response.material_safety_data_sheet.length;
              i++
            ) {
              let obj = {
                filename: response.material_safety_data_sheet[i].meta.filename,
                fileurl: response.material_safety_data_sheet[i].url,
                fileid: response.material_safety_data_sheet[i].msds_id,
              };
              this.allmaterialname.push(obj);
            }
          }

          // get stowage plan
          if (response.stowage_plan != null) {
            for (var i = 0; i < response.stowage_plan.length; i++) {
              let obj = {
                filename: response.stowage_plan[i].meta.filename,
                fileurl: response.stowage_plan[i].url,
                fileid: response.stowage_plan[i].stowage_plan_id,
              };
              this.allstowagename.push(obj);
            }
          }

          if (response.waste_job_document != null) {
            for (var i = 0; i < response.waste_job_document.length; i++) {
              let obj = {
                filename: response.waste_job_document[i].meta.filename,
                fileurl: response.waste_job_document[i].url,
                fileid: response.waste_job_document[i].waste_job_document_id,
              };
              this.allfilename.push(obj);
            }
          }

          //get quo docs
          if (response.quotation != null)
            if (response.quotation.quotation_support_document != null) {
              for (
                var i = 0;
                i < response.quotation.quotation_support_document.length;
                i++
              ) {
                let obj = {
                  filename:
                    response.quotation.quotation_support_document[i].filename,
                  fileurl: response.quotation.quotation_support_document[i].url,
                  fileid:
                    response.quotation.quotation_support_document[i]
                      .quotation_support_document_id,
                };
                this.allquodocname.push(obj);
              }
            }

          for (var i = 0; i < response.waste_detail.length; i++) {
            let obj = {
              no: i + 1,
              wastetype:
                response.waste_detail[i].waste_type_name == ""
                  ? "N/A"
                  : response.waste_detail[i].waste_type_name,
              wastetypesub:
                response.waste_detail[i].waste_type_sub_name == ""
                  ? "N/A"
                  : response.waste_detail[i].waste_type_sub_name,
              wasteqty:
                response.waste_detail[i].estimated_quantity +
                " " +
                response.waste_detail[i].estimated_quantity_unit,
              maxdedicatedstoragecapacity:
                response.waste_detail[i].dedicated_storage_capacity +
                " " +
                response.waste_detail[i].dedicated_storage_capacity_unit,
              wasteamountretainedonboard:
                response.waste_detail[i].waste_retained_onboard +
                " " +
                response.waste_detail[i].waste_retained_onboard_unit,
              remarks: response.waste_detail[i].remarks,
              wastecatalyst: response.waste_detail[i].waste_type_sub_name,
              packagingtype: response.waste_detail[i].packaging_type_name,
              wasteorigin: response.waste_detail[i].waste_source,
              wastecomponent: response.waste_detail[i].waste_component,
              // estqty: response.waste_detail[i].estimated_quantity,
              estqty:
                response.waste_detail[i].estimated_quantity +
                " " +
                response.waste_detail[i].estimated_quantity_unit,
              estqtyy:
                response.waste_detail[i].packaging_quantity +
                " " +
                response.waste_detail[i].packaging_type_name,
              image: response.waste_detail[i].images,
            };

            this.wastedetails.push(obj);
          }
        }
      });
    },
    nextTab() {
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    ptwTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    async exitTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },
    onImageChange(file) {
      this.images.regular = file;

      this.img = file.name;

      const reader = new FileReader();

      reader.onload = (event) => {
        file = event.target.result;

        file.replace(event.target.result);

        this.imagebase64 = file.split(",")[1];
      };
      reader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {
    jobstatus() {
      if (this.jobstatus.toUpperCase() == "QUOTATION") {
        this.nextTab();
      }
      if (this.jobstatus.toUpperCase() == "PTW") {
        this.ptwTab();
      }
    },
    step() {
      console.log(" step started ");

      if (this.step == 1) {
        let parameter = {
          step: "0",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 2) {
        let parameter = {
          step: "1",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 3) {
        let parameter = {
          step: "2",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 4) {
        let parameter = {
          step: "3",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 5) {
        let parameter = {
          step: "4",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 6) {
        let parameter = {
          step: "5",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  background-color: 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.floating-buttons-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

/* Styles for floating buttons */
.floating-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  width: 80px;
  z-index: 9999;
  left: 20px;
  /* Adjust as needed */
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

.scrollable-content {
  flex: 0 0 auto;
  white-space: nowrap;
  margin-right: 15px;
  /* Adjust as needed */
}

.el-table .cell {
  word-break: break-word !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
